"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

require("core-js/modules/es6.symbol.js");

require("core-js/modules/es6.string.iterator.js");

require("core-js/modules/es6.object.to-string.js");

require("core-js/modules/es6.array.iterator.js");

require("core-js/modules/web.dom.iterable.js");

require("core-js/modules/es6.array.slice.js");

require("core-js/modules/es6.function.name.js");

require("core-js/modules/es6.array.from.js");

require("core-js/modules/es6.weak-map.js");

require("core-js/modules/es6.object.get-own-property-descriptor.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es7.array.includes.js");

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _reactRouter = require("react-router");

var _utils = require("../../lib/utils");

var _user = require("@evdy/web-redux/dist/actions/dash/user");

var _MobileMenu = _interopRequireDefault(require("../shared/elements/MobileMenu"));

var _UserWelcome = _interopRequireDefault(require("../shared/elements/UserWelcome"));

var _SimpleGradientButton = _interopRequireDefault(require("../shared/SimpleGradientButton"));

require("./PagesHeader.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var b2bPages = ['partners', 'pricing', 'demo', 'get-started'];

var PagesHeader = function PagesHeader(props) {
  var dispatch = props.dispatch,
      currentPage = props.currentPage,
      user = props.user,
      inbox = props.inbox,
      pathname = props.pathname,
      _props$queryString = props.queryString,
      queryString = _props$queryString === void 0 ? '' : _props$queryString,
      _props$showAuthLinks = props.showAuthLinks,
      showAuthLinks = _props$showAuthLinks === void 0 ? true : _props$showAuthLinks;
  var mobileMenu = (0, _react.useRef)(null);

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isMobile = _useState2[0],
      setIsMobile = _useState2[1];

  (0, _react.useEffect)(function () {
    if (global.window) {
      var _isMobile = window.innerWidth < 768;

      setIsMobile(_isMobile);
    }
  }, []);

  var handleAuthModal = function handleAuthModal(e, type) {
    var path = pathname === '/' ? '' : pathname;
    var memorialURL = "".concat(path, "/").concat(type).concat(queryString);

    _reactRouter.browserHistory.push(memorialURL);
  };

  var handleAuthLinkClick = function handleAuthLinkClick(type) {
    if (currentPage === 'partners') {
      var dashURL = type === 'signup' ? '/dash/signup' : '/dash';
      return window.open(dashURL, '_blank');
    }

    handleAuthModal('', type);
  };

  var handleSearchClick = function handleSearchClick() {
    var path = pathname === '/' ? '' : pathname;

    _reactRouter.browserHistory.push("".concat(path, "/memorialsearch"));

    (0, _utils.googleAnalytics)("search")();
  };

  var handleSignOut = function handleSignOut() {
    dispatch((0, _user.signOut)(window.location.href));
  };

  var renderNav = function renderNav(currentPage) {
    var _mobileMenu$current;

    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
      className: "header-hamburger",
      onClick: (_mobileMenu$current = mobileMenu.current) === null || _mobileMenu$current === void 0 ? void 0 : _mobileMenu$current.setMobileMenu(true)
    }), /*#__PURE__*/_react.default.createElement("a", {
      href: "/"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "header-logo"
    })), !b2bPages.includes(currentPage) && /*#__PURE__*/_react.default.createElement("div", {
      className: "header-search",
      onClick: function onClick() {
        handleSearchClick();
      }
    }));
  };

  var renderUserWelcome = function renderUserWelcome() {
    return /*#__PURE__*/_react.default.createElement(_UserWelcome.default, {
      user: user,
      inbox: inbox,
      handleSignOut: handleSignOut,
      pathname: pathname
    });
  };

  var renderAuthButtons = function renderAuthButtons() {
    var currentPage = props.currentPage;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "auth-buttons"
    }, /*#__PURE__*/_react.default.createElement("button", {
      id: "".concat(currentPage, "_header_login"),
      className: "login",
      onClick: function onClick() {
        return handleAuthLinkClick('login');
      }
    }, "Sign in"), /*#__PURE__*/_react.default.createElement("button", {
      id: "".concat(currentPage, "_header_signup"),
      className: "signup",
      onClick: function onClick() {
        return handleAuthLinkClick('signup');
      }
    }, "Get Started"));
  };

  var renderB2B = function renderB2B(currentPage) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
      className: "header-left"
    }, renderNav(), /*#__PURE__*/_react.default.createElement("div", {
      className: "header-links"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "other-pages-links"
    }, /*#__PURE__*/_react.default.createElement("a", {
      id: "".concat(currentPage, "_header_partners_link"),
      href: "https://clients.everdays.com/for-homes",
      className: currentPage === 'partners' && 'current-page'
    }, "For Homes"), /*#__PURE__*/_react.default.createElement("a", {
      id: "".concat(currentPage, "_header_pricing_link"),
      href: "https://clients.everdays.com/pricing",
      className: currentPage === 'pricing' && 'current-page'
    }, "Pricing"), /*#__PURE__*/_react.default.createElement("a", {
      id: "".concat(currentPage, "_header_demo_link"),
      href: "https://clients.everdays.com/get-demo",
      className: currentPage === 'demo' && 'current-page'
    }, "Demo"), /*#__PURE__*/_react.default.createElement("a", {
      id: "".concat(currentPage, "_resources_link"),
      href: "https://learn.everdays.com/blog/",
      className: currentPage === 'resources' && 'current-page'
    }, "Blog")))), /*#__PURE__*/_react.default.createElement("div", {
      className: "right-buttons-wrapper"
    }, /*#__PURE__*/_react.default.createElement("a", {
      className: "b2b-header-log-in",
      href: "/dash"
    }, "Log in"), /*#__PURE__*/_react.default.createElement(_SimpleGradientButton.default, {
      customClasses: ['header-get-app-button'],
      href: "https://everdays.com/get-started"
    }, "Get Started Today")));
  };

  var renderAtNeed = function renderAtNeed(currentPage) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
      className: "header-left"
    }, renderNav(), /*#__PURE__*/_react.default.createElement("div", {
      className: "header-links"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "other-pages-links"
    }, /*#__PURE__*/_react.default.createElement("a", {
      id: "".concat(currentPage, "_header_home_link"),
      href: "/why/",
      className: currentPage === 'home' && 'current-page'
    }, "Why Everdays"), /*#__PURE__*/_react.default.createElement("a", {
      id: "".concat(currentPage, "_header_partners_link"),
      href: "/how-it-works/"
    }, "How It Works")))), /*#__PURE__*/_react.default.createElement(_SimpleGradientButton.default, {
      customClasses: ['header-get-app-button'],
      href: "/get-my-price/"
    }, "Get My Price"));
  };

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "pages-header"
  }, b2bPages.includes(currentPage) ? renderB2B(currentPage) : renderAtNeed(currentPage), /*#__PURE__*/_react.default.createElement(_MobileMenu.default, {
    currentPage: currentPage,
    handleAuthModal: handleAuthModal,
    handleSignOut: handleSignOut,
    ref: mobileMenu,
    openSearchModal: handleSearchClick,
    showAuthLinks: showAuthLinks
  }));
};

var _default = (0, _reactRedux.connect)(function (_ref) {
  var dash = _ref.dash,
      fetchInbox = _ref.fetchInbox;
  return {
    user: dash.user.data,
    inbox: fetchInbox.inbox.data
  };
})(PagesHeader);

exports.default = _default;